import {
  Button,
  type ButtonProps,
  Checkbox,
  type CheckboxProps,
  FormControlLabel,
  type FormControlLabelProps,
  ListItemButton,
  type ListItemButtonProps,
  Radio,
  type RadioProps,
  styled,
} from '@mui/material';
import type { ComponentType } from 'react';

export const CustomButton: ComponentType<ButtonProps> = styled(Button)({
  backgroundColor: '#fff',
  color: '#000',
  textTransform: 'capitalize',
  fontSize: '13px',
  padding: '0px 5px',
  marginRight: '2px',
  border: '1px solid',
  '&:hover': {
    backgroundColor: '#000',
    color: '#fff',
    borderColor: '#fff',
    border: '1px solid',
    boxShadow: 'none',
  },
});

export const CustomFormControlLabel: ComponentType<FormControlLabelProps> = styled(
  FormControlLabel,
)({
  '& .MuiFormControlLabel-label': { fontSize: 14 },
});

export const CustomCheckBox: ComponentType<CheckboxProps> = styled(Checkbox)({
  color: '#0075ff',
  '&.Mui-checked': {
    color: '#0075ff',
  },
  '& .MuiSvgIcon-root': { fontSize: 16 },
});

export const CustomRadio: ComponentType<RadioProps> = styled(Radio)(() => ({
  color: '#0075ff',
  '&.Mui-checked': {
    color: '#0075ff',
  },
  '& .MuiSvgIcon-root': { fontSize: 16 },
}));

export const DrawerListItems: ComponentType<ListItemButtonProps> = styled(ListItemButton)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: '#9c27b0',
  textAlign: 'center',
});
